import React from "react";

export const Culture = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 64 64"
            {...props}
        >
            <circle cx="32" cy="23" r="19" fill="#ffdc42"></circle>
            <path fill="#e3e3e3" d="M45 23a13 13 0 01-26 0h-6a19 19 0 0038 0z"></path>
            <path fill="#936226" d="M55 19H37V1H27v18H9v10h18v34h10V29h18z"></path>
            <g fill="#f4f4f4">
                <path d="M44 19h6v22h-6zM14 19h6v22h-6z"></path>
            </g>
        </svg>
    );
}

export default Culture;